// import { useMemo, useState } from "react";
// import { Radio } from "antd";
// import { useFetchAllRoleImpactOnOrganisationQuery } from "@services";
// import { groupRoleImpactData } from "@/utils/roleImpact";

// interface RoleImpactSelectorProps {
//     onSelect: (value: { key: string; display_name: string }) => void;
// }

// const RoleImpactSelector: React.FC<RoleImpactSelectorProps> = ({ onSelect }) => {
//     const { data } = useFetchAllRoleImpactOnOrganisationQuery(null);

//     const roleImpactData = useMemo(() => {
//         if (!data?.data) return null;
//         return groupRoleImpactData(data.data);
//     }, [data]);

//     const [roleType, setRoleType] =
//         useState<"LEADERSHIP" | "NON_LEADERSHIP" | null>(null);
//     const [leadershipRole, setLeadershipRole] =
//         useState<"function_head" | "business_head" | null>(null);
//     const [scope, setScope] =
//         useState<"single_bu" | "multiple_bu" | null>(null);
//     const [selectedKey, setSelectedKey] = useState<string | null>(null);

//     if (!roleImpactData) return null;

//     const selectFinal = (item: any) => {
//         setSelectedKey(item.rawKey);
//         onSelect({
//             key: item.rawKey,
//             display_name: item.displayName,
//         });
//     };

//     return (
//         <div>
//             {/* ROLE TYPE BUTTONS */}
//             <div className="flex flex-row items-center gap-5 mb-6">
//                 <button
//                     className={`px-14 py-3 text-[#00519D] font-medium text-[24px] rounded-[10px] shadow-sm shadow-[#00000040]
//             ${roleType === "LEADERSHIP" ? "bg-[#e8e2ff]" : "bg-[#F8F6FF]"}`}
//                     onClick={() => {
//                         setRoleType("LEADERSHIP");
//                         setLeadershipRole(null);
//                         setScope(null);
//                         setSelectedKey(null);
//                     }}
//                 >
//                     Leadership Role
//                 </button>

//                 <button
//                     className={`px-14 py-3 text-[#00519D] font-medium text-[24px] rounded-[10px] shadow-sm shadow-[#00000040]
//             ${roleType === "NON_LEADERSHIP" ? "bg-[#e8e2ff]" : "bg-[#F8F6FF]"}`}
//                     onClick={() => {
//                         setRoleType("NON_LEADERSHIP");
//                         setSelectedKey(null);
//                     }}
//                 >
//                     Non-Leadership Role
//                 </button>
//             </div>

//             {/* NON-LEADERSHIP */}
//             {roleType === "NON_LEADERSHIP" && (
//                 <div className="flex items-center gap-4">
//                     {roleImpactData.nonLeadership.map(item => (
//                         <button
//                             key={item.rawKey}
//                             className={`px-14 py-3 font-medium rounded-[10px] shadow-sm shadow-[#00000040]
//                 ${selectedKey === item.rawKey
//                                     ? "bg-[#e8e2ff] text-[#00519D]"
//                                     : "bg-[#F8F6FF] text-[#00519D]"
//                                 }`}
//                             onClick={() => selectFinal(item)}
//                         >
//                             {item.displayName}
//                         </button>
//                     ))}
//                 </div>
//             )}

//             {/* LEADERSHIP (MATCHES OLD UI EXACTLY) */}
//             {roleType === "LEADERSHIP" && (
//                 <div className="mt-6 flex items-center  gap-2 bg-[#F4F7FB] p-6 rounded-lg">

//                     {/* FUNCTION HEAD COLUMN */}
//                     <div>
//                         <Radio
//                             checked={leadershipRole === "function_head"}
//                             onChange={() => {
//                                 setLeadershipRole("function_head");
//                                 setScope(null);
//                                 setSelectedKey(null);
//                             }}
//                             className="text-lg font-medium mb-4"
//                         >
//                             Function Head
//                         </Radio>

//                         <div className="flex flex-col gap-4 ml-6">
//                             <Radio
//                                 disabled={leadershipRole !== "function_head"}
//                                 checked={
//                                     leadershipRole === "function_head" && scope === "single_bu"
//                                 }
//                                 onChange={() => setScope("single_bu")}
//                             >
//                                 Single Business Unit
//                             </Radio>

//                             <Radio
//                                 disabled={leadershipRole !== "function_head"}
//                                 checked={
//                                     leadershipRole === "function_head" && scope === "multiple_bu"
//                                 }
//                                 onChange={() => setScope("multiple_bu")}
//                             >
//                                 Multiple Business Units
//                             </Radio>
//                         </div>
//                     </div>

//                     {/* BUSINESS HEAD COLUMN */}
//                     {/* BUSINESS HEAD COLUMN */}
//                     <div>
//                         <Radio
//                             checked={leadershipRole === "business_head"}
//                             onChange={() => {
//                                 setLeadershipRole("business_head");
//                                 setScope(null);
//                                 setSelectedKey(null);
//                             }}
//                             className="text-lg font-medium mb-4"
//                         >
//                             Business Head
//                         </Radio>

//                         <div className="flex flex-col gap-4 ml-6">
//                             <Radio
//                                 disabled={leadershipRole !== "business_head"}
//                                 checked={
//                                     leadershipRole === "business_head" && scope === "single_bu"
//                                 }
//                                 onChange={() => setScope("single_bu")}
//                             >
//                                 Single Business Unit
//                             </Radio>

//                             <Radio
//                                 disabled={leadershipRole !== "business_head"}
//                                 checked={
//                                     leadershipRole === "business_head" && scope === "multiple_bu"
//                                 }
//                                 onChange={() => setScope("multiple_bu")}
//                             >
//                                 Multiple Business Units
//                             </Radio>
//                         </div>
//                     </div>

//                 </div>
//             )}

//             {/* GEOGRAPHY BUTTONS */}
//             {roleType === "LEADERSHIP" && leadershipRole && scope && (
//                 <div className="flex flex-row gap-4 mt-6">
//                     {roleImpactData.leadership[leadershipRole][scope].map(item => (
//                         <button
//                             key={item.rawKey}
//                             className={`px-10 py-2 font-medium rounded-[8px]
//                 ${selectedKey === item.rawKey
//                                     ? "bg-[#e8e2ff] text-[#00519D]"
//                                     : "bg-[#F8F6FF] text-[#00519D]"
//                                 }`}
//                             onClick={() => selectFinal(item)}
//                         >
//                             {item.displayName}
//                         </button>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default RoleImpactSelector;

// import { useEffect, useMemo, useState } from "react";
// import { Radio } from "antd";
// import { useFetchAllRoleImpactOnOrganisationQuery } from "@services";
// import { groupRoleImpactData } from "@/utils/roleImpact";

// interface RoleImpactValue {
//   key: string;
//   display_name: string;
// }

// interface RoleImpactItem {
//   rawKey: string;
//   displayName: string;
// }

// interface RoleImpactSelectorProps {
//   value?: RoleImpactValue | null;
//   onSelect: (value: RoleImpactValue) => void;
// }

// type RoleType = "LEADERSHIP" | "NON_LEADERSHIP";
// type LeadershipRole = "function_head" | "business_head";
// type Scope = "single_bu" | "multiple_bu";

// const RoleImpactSelector: React.FC<RoleImpactSelectorProps> = ({
//   value,
//   onSelect,
// }) => {
//   const { data } = useFetchAllRoleImpactOnOrganisationQuery(null);

//   const roleImpactData = useMemo(() => {
//     if (!data?.data) return null;
//     return groupRoleImpactData(data.data);
//   }, [data]);

//   const [roleType, setRoleType] = useState<RoleType | null>(null);
//   const [leadershipRole, setLeadershipRole] =
//     useState<LeadershipRole | null>(null);
//   const [scope, setScope] = useState<Scope | null>(null);
//   const [selectedKey, setSelectedKey] = useState<string | null>(null);

//   /* ---------------------------------- */
//   /* RECONSTRUCT UI FROM SAVED VALUE     */
//   /* ---------------------------------- */
//   useEffect(() => {
//     if (!value?.key || !roleImpactData) return;

//     // NON-LEADERSHIP
//     const nonLeadershipMatch = roleImpactData.nonLeadership.find(
//       (i: RoleImpactItem) => i.rawKey === value.key
//     );

//     if (nonLeadershipMatch) {
//       setRoleType("NON_LEADERSHIP");
//       setLeadershipRole(null);
//       setScope(null);
//       setSelectedKey(value.key);
//       return;
//     }

//     // LEADERSHIP
//     (["function_head", "business_head"] as LeadershipRole[]).forEach(role => {
//       (["single_bu", "multiple_bu"] as Scope[]).forEach(sc => {
//         const match = roleImpactData.leadership[role][sc].find(
//           (i: RoleImpactItem) => i.rawKey === value.key
//         );

//         if (match) {
//           setRoleType("LEADERSHIP");
//           setLeadershipRole(role);
//           setScope(sc);
//           setSelectedKey(value.key);
//         }
//       });
//     });
//   }, [value?.key, roleImpactData]);

//   if (!roleImpactData) return null;

//   const resetSelection = () => {
//     setSelectedKey(null);
//     onSelect({ key: "", display_name: "" });
//   };

//   const selectFinal = (item: RoleImpactItem) => {
//     setSelectedKey(item.rawKey);
//     onSelect({
//       key: item.rawKey,
//       display_name: item.displayName,
//     });
//   };

//   return (
//     <div>
//       {/* ROLE TYPE */}
//       <div className="flex gap-5 mb-6">
//         <button
//           className={`px-14 py-3 text-[#00519D] text-[24px] rounded-[10px]
//           ${roleType === "LEADERSHIP" ? "bg-[#e8e2ff]" : "bg-[#F8F6FF]"}`}
//           onClick={() => {
//             setRoleType("LEADERSHIP");
//             setLeadershipRole(null);
//             setScope(null);
//             resetSelection();
//           }}
//         >
//           Leadership Role
//         </button>

//         <button
//           className={`px-14 py-3 text-[#00519D] text-[24px] rounded-[10px]
//           ${roleType === "NON_LEADERSHIP" ? "bg-[#e8e2ff]" : "bg-[#F8F6FF]"}`}
//           onClick={() => {
//             setRoleType("NON_LEADERSHIP");
//             setLeadershipRole(null);
//             setScope(null);
//             resetSelection();
//           }}
//         >
//           Non-Leadership Role
//         </button>
//       </div>

//       {/* NON-LEADERSHIP */}
//       {roleType === "NON_LEADERSHIP" && (
//         <div className="flex gap-4">
//           {roleImpactData.nonLeadership.map((item: RoleImpactItem) => (
//             <button
//               key={item.rawKey}
//               className={`px-14 py-3 rounded-[10px]
//               ${
//                 selectedKey === item.rawKey
//                   ? "bg-[#e8e2ff]"
//                   : "bg-[#F8F6FF]"
//               }`}
//               onClick={() => selectFinal(item)}
//             >
//               {item.displayName}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* LEADERSHIP */}
//       {roleType === "LEADERSHIP" && (
//         <div className="mt-6 flex gap-10 bg-[#F4F7FB] p-6 rounded-lg">
//           {(["function_head", "business_head"] as LeadershipRole[]).map(role => (
//             <div key={role}>
//               <Radio
//                 checked={leadershipRole === role}
//                 onChange={() => {
//                   setLeadershipRole(role);
//                   setScope(null);
//                   resetSelection();
//                 }}
//               >
//                 {role === "function_head" ? "Function Head" : "Business Head"}
//               </Radio>

//               <div className="ml-6 mt-4 flex flex-col gap-3">
//                 {(["single_bu", "multiple_bu"] as Scope[]).map(sc => (
//                   <Radio
//                     key={sc}
//                     disabled={leadershipRole !== role}
//                     checked={leadershipRole === role && scope === sc}
//                     onChange={() => {
//                       setScope(sc);
//                       resetSelection();
//                     }}
//                   >
//                     {sc === "single_bu"
//                       ? "Single Business Unit"
//                       : "Multiple Business Units"}
//                   </Radio>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* FINAL OPTIONS */}
//       {roleType === "LEADERSHIP" && leadershipRole && scope && (
//         <div className="flex gap-4 mt-6">
//           {roleImpactData.leadership[leadershipRole][scope].map(
//             (item: RoleImpactItem) => (
//               <button
//                 key={item.rawKey}
//                 className={`px-10 py-2 rounded-[8px]
//                 ${
//                   selectedKey === item.rawKey
//                     ? "bg-[#e8e2ff]"
//                     : "bg-[#F8F6FF]"
//                 }`}
//                 onClick={() => selectFinal(item)}
//               >
//                 {item.displayName}
//               </button>
//             )
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default RoleImpactSelector;

import { useEffect, useMemo, useState } from "react";
import { Radio } from "antd";
import { useFetchAllRoleImpactOnOrganisationQuery } from "@services";
import { groupRoleImpactData } from "@/utils/roleImpact";

interface RoleImpactValue {
  key: string;
  display_name: string;
}

interface RoleImpactItem {
  rawKey: string;
  displayName: string;
}

interface RoleImpactSelectorProps {
  value?: RoleImpactValue | null;
  onSelect: (value: RoleImpactValue) => void;
}

type RoleType = "LEADERSHIP" | "NON_LEADERSHIP";
type LeadershipRole = "function_head" | "business_head";
type Scope = "single_bu" | "multiple_bu";

const RoleImpactSelector: React.FC<RoleImpactSelectorProps> = ({
  value,
  onSelect,
}) => {
  const { data } = useFetchAllRoleImpactOnOrganisationQuery(null);

  const roleImpactData = useMemo(() => {
    if (!data?.data) return null;
    return groupRoleImpactData(data.data);
  }, [data]);

  const [roleType, setRoleType] = useState<RoleType | null>(null);
  const [leadershipRole, setLeadershipRole] = useState<LeadershipRole | null>(
    null
  );
  const [scope, setScope] = useState<Scope | null>(null);
  const [selectedKey, setSelectedKey] = useState<string | null>(null);

  /* ---------------------------------- */
  /* RESTORE UI FROM SAVED VALUE         */
  /* ---------------------------------- */
  useEffect(() => {
    if (!value?.key || !roleImpactData) return;

    // NON-LEADERSHIP
    const nonLeadership = roleImpactData.nonLeadership.find(
      (i: RoleImpactItem) => i.rawKey === value.key
    );

    if (nonLeadership) {
      setRoleType("NON_LEADERSHIP");
      setLeadershipRole(null);
      setScope(null);
      setSelectedKey(value.key);
      return;
    }

    // LEADERSHIP
    (["function_head", "business_head"] as LeadershipRole[]).forEach(role => {
      (["single_bu", "multiple_bu"] as Scope[]).forEach(sc => {
        const match = roleImpactData.leadership[role][sc].find(
          (i: RoleImpactItem) => i.rawKey === value.key
        );

        if (match) {
          setRoleType("LEADERSHIP");
          setLeadershipRole(role);
          setScope(sc);
          setSelectedKey(value.key);
        }
      });
    });
  }, [value?.key, roleImpactData]);

  if (!roleImpactData) return null;

  /* ---------------------------------- */
  /* IMPORTANT: DO NOT TOUCH REDUX HERE  */
  /* ---------------------------------- */
  const resetLocalSelection = () => {
    setSelectedKey(null);
  };

  const selectFinal = (item: RoleImpactItem) => {
    setSelectedKey(item.rawKey);
    onSelect({
      key: item.rawKey,
      display_name: item.displayName,
    });
  };

  return (
    <div>
      {/* ROLE TYPE */}
      <div className="flex gap-5 mb-6">
        <button
          className={`px-14 py-2 text-white text-[20px] rounded-[10px]
          ${
            roleType === "LEADERSHIP"
              ? "bg-bgSidebar"
              : "bg-bgSidebar opacity-50"
          }`}
          onClick={() => {
            setRoleType("LEADERSHIP");
            setLeadershipRole(null);
            setScope(null);
            resetLocalSelection();
          }}
        >
          Leadership Role
        </button>

        <button
          className={`px-14 py-2 text-white text-[20px] rounded-[10px]
          ${
            roleType === "NON_LEADERSHIP"
              ? "bg-bgSidebar"
              : "bg-bgSidebar opacity-50"
          }`}
          onClick={() => {
            setRoleType("NON_LEADERSHIP");
            setLeadershipRole(null);
            setScope(null);
            resetLocalSelection();
          }}
        >
          Non-Leadership Role
        </button>
      </div>

      {/* NON-LEADERSHIP */}
      {roleType === "NON_LEADERSHIP" && (
        <div className="flex gap-4">
          {roleImpactData.nonLeadership.map((item: RoleImpactItem) => (
            <button
              key={item.rawKey}
              className={`px-14 py-3 rounded-[10px]
              ${
                selectedKey === item.rawKey
                  ? "bg-bgSidebar text-white"
                  : "bg-bgSidebar text-white opacity-50"
              }`}
              onClick={() => selectFinal(item)}
            >
              {item.displayName}
            </button>
          ))}
        </div>
      )}

      {/* LEADERSHIP */}
      {roleType === "LEADERSHIP" && (
        <div className="mt-6 flex gap-10 bg-[#F4F7FB] p-6 rounded-lg">
          {(["function_head", "business_head"] as LeadershipRole[]).map(
            role => (
              <div key={role}>
                <Radio
                  checked={leadershipRole === role}
                  onChange={() => {
                    setLeadershipRole(role);
                    setScope(null);
                    resetLocalSelection();
                  }}
                >
                  {role === "function_head" ? "Function Head" : "Business Head"}
                </Radio>

                <div className="ml-6 mt-4 flex flex-col gap-3">
                  {(["single_bu", "multiple_bu"] as Scope[]).map(sc => (
                    <Radio
                      key={sc}
                      disabled={leadershipRole !== role}
                      checked={leadershipRole === role && scope === sc}
                      onChange={() => {
                        setScope(sc);
                        resetLocalSelection();
                      }}
                    >
                      {sc === "single_bu"
                        ? "Single Business Unit"
                        : "Multiple Business Units"}
                    </Radio>
                  ))}
                </div>
              </div>
            )
          )}
        </div>
      )}

      {/* FINAL SELECTION */}
      {roleType === "LEADERSHIP" && leadershipRole && scope && (
        <div className="flex gap-4 mt-6">
          {roleImpactData.leadership[leadershipRole][scope].map(
            (item: RoleImpactItem) => (
              <button
                key={item.rawKey}
                className={`px-10 py-2 rounded-[8px]
                ${
                  selectedKey === item.rawKey ? "bg-[#e8e2ff]" : "bg-[#F8F6FF]"
                }`}
                onClick={() => selectFinal(item)}
              >
                {item?.displayName.split(" - ").pop() ?? item?.displayName}
              </button>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default RoleImpactSelector;
